import React from "react";
import {
  AccordianContainer,
  AccordianTitleBox,
  AccordianItemBox,
  AccordianBox,
  Title,
  DeleteBox,
  ArrowBox,
} from "./accordian-components";
import { Icon, ToolTip } from "@app/components";
type Props = {
  children: any;
  title: string;
  deleteChild: (e: any) => void;
  isActive: boolean;
  showDelete: boolean;
  toggleAccordian: (e: any) => void;
  notValid?: boolean;
  isValid?: boolean;
  id: number;
};

export default function Accordian({
  children,
  title,
  deleteChild,
  isActive,
  showDelete,
  toggleAccordian,
  notValid,
  isValid,
  id,
}: Props) {
  return (
    <React.Fragment>
      <AccordianContainer>
        <AccordianItemBox notValid={notValid} isValid={isValid}>
          <AccordianBox active={isActive || !showDelete}>
            <AccordianTitleBox
              onClick={showDelete ? toggleAccordian : () => {}}
            >
              {showDelete && (
                <ArrowBox className="mr-1">
                  {isActive ? (
                    <Icon name="upArrow" />
                  ) : (
                    <Icon name="arrowDown" />
                  )}
                </ArrowBox>
              )}
              <Title>{title}</Title>
            </AccordianTitleBox>
            <AccordianTitleBox>
              {showDelete && (
                <>
                  <DeleteBox
                    onClick={deleteChild}
                    data-tip
                    data-for={`delete_${id + 1}`}
                  >
                    <Icon name="delete" />
                  </DeleteBox>
                  <ToolTip id={`delete_${id + 1}`} text="Delete Child" />
                </>
              )}
            </AccordianTitleBox>
          </AccordianBox>
          {isActive || !showDelete ? children : null}
        </AccordianItemBox>
      </AccordianContainer>
    </React.Fragment>
  );
}
